import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { LeadForm } from "@/components/marketing/LeadForm";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { CONTACT } from "@/content/pages";

export default function Contact() {
  return (
    <PageShell testid="contact-root" seo={{
      title: "Contact — Sema",
      description: "Talk to sales, get support, or reach our security team. Or book a walkthrough of Sema on your own data.",
      keywords: "contact sema, sales, support, security, book demo",
      path: "/contact",
    }}>
      <PageHero testid="contact-h1" eyebrow="Contact"
        title="Let's talk."
        subtitle="Book a walkthrough, ask a question, or reach the right team directly." />

      <section className="pb-24">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-12 px-6 lg:grid-cols-2 lg:gap-16">
          <div className="space-y-5">
            {CONTACT.channels.map((c) => (
              <div key={c.title} data-testid={`contact-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="rounded-2xl border border-border/60 bg-card/50 p-6 backdrop-blur">
                <div className="flex items-start gap-4">
                  <span className="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-accent/15 text-accent">
                    <LucideIcon name={c.icon} className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="text-base font-semibold tracking-tight">{c.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{c.body}</p>
                    <a href={`mailto:${c.email}`} className="mt-2 inline-block font-mono text-[12px] text-accent hover:underline">{c.email}</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <LeadForm industry="" accent="#0FAE96" source="contact" />
        </div>
      </section>
    </PageShell>
  );
}
